import React, { useState, useEffect } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';
import ScatterPlot from 'components/charts/ScatterChart';
import { volcanoChartOptions, fetchDiffVolcanoData } from '../variables/data';

export default function Conversion(props) {
    const { ...rest } = props;

    // Chakra Color Mode
    const cardColor = useColorModeValue('white', 'navy.700');
    const cardShadow = useColorModeValue(
        '0px 18px 40px rgba(112, 144, 176, 0.12)',
        'unset'
    );


    const [chartData, setChartData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        console.log('Received selectedOption:', props.selectedOption); // Debug log
        const fetchDataAndUpdateState = async () => {
            try {
                setIsLoading(true);
                setHasError(false); // Reset the error state
                const newData = await fetchDiffVolcanoData(props);

                // Check if newData and newData.data is not undefined
                if (newData && newData.data) {
                    setChartData(newData.data);
                    setIsLoading(false);
                } else {
                    // newData or newData.data is undefined. Handle it here if needed.
                    console.error('Data is undefined.');
                    setHasError(true);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('An error occurred while fetching data:', error);
                setHasError(true);
                setIsLoading(false);
            }
        };

        fetchDataAndUpdateState();
    }, [props.selectedOption]);

    // console.log(chartData)

    return (

        <Card p='20px' align='center' direction='column' w='100%' {...rest}>

        {isLoading ? (
            <p>Loading...</p>
        ) : hasError ? (
            <p>Error occurred while fetching data.</p>
        ) : (
            <div style={{ marginRight: '10%' }}>
            <ScatterPlot chartOptions={volcanoChartOptions} chartData={chartData} />
            </div>
    
        )}

    </Card>


    );
}


// import React, { useState, useEffect } from 'react';
// import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
// import Card from 'components/card/Card.js';

// import axios from 'axios';

// export default function Conversion(props) {
//     const { ...rest } = props;

//     // Chakra Color Mode
//     const cardColor = useColorModeValue('white', 'navy.700');
//     const cardShadow = useColorModeValue(
//         '0px 18px 40px rgba(112, 144, 176, 0.12)',
//         'unset'
//     );

//     const [imageBase64, setImageBase64] = useState("");
//     const [error, setError] = useState(null); // Initialize error state

//     useEffect(() => {
//         // Check if selectedOption is not null and has a value field
//         if (props.selectedOption && props.selectedOption.value) {
//             // Use the selectedOption.value in the API URL
//             const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
//             const apiUrl = `${api_host}/api/get-diff-volcano-image/?project=${props.selectedOption.value}`;

//             axios.get(apiUrl)
//                 .then(response => {
//                     setImageBase64(response.data.image_base64);
//                 })
//                 .catch(err => {
//                     setError("Failed to fetch image."); // Set error state
//                     console.error("Error fetching image: ", err);
//                 });
//         }
//     }, [props.selectedOption]);

//     return (
//         <Card p='20px' align='center' direction='column' w='100%' {...rest}>
//             <div className="App">
//                 <Box mb={4}>
//                     <h3>Concordantly regulated phosphoprotein and glycoprotein pairs in oncogenic transition</h3>
//                 </Box>
//                 {imageBase64 && <img src={`data:image/jpeg;base64,${imageBase64}`} alt="description" />}
//                 {error && <p>{error}</p>} {/* Display error message */}
//             </div>
//         </Card>
//     );
// }
